import { IRootScopeService, IScope } from "angular";
import { AccountService } from "@gtmhub/accounts/accountsService";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { FileService } from "@gtmhub/files";
import { IBrandingImage } from "../models";

interface IBrandingScope extends IScope {
  indicators: {
    uploading?: boolean;
  };
  picFile?: Blob;
  uploadedFileUrl?: string;
  selectFile($file: Blob): void;
  upload(): void;
  reset(): void;
  delete(): void;
}

export class BrandingCtrl {
  public static $inject = ["$rootScope", "$scope", "FileService", "AccountService", "UIErrorHandlingService"];

  constructor(
    private $rootScope: IRootScopeService,
    private $scope: IBrandingScope,
    private fileService: FileService,
    private accountService: AccountService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    this.$scope.indicators = {};
    this.$scope.upload = this.upload;
    this.$scope.delete = this.delete;
    this.$scope.reset = this.reset;
    this.$scope.selectFile = this.selectFile;
  }

  private selectFile = ($file: File): void => {
    this.$scope.picFile = $file;
  };

  private reset = (): void => {
    this.$scope.picFile = null;
  };

  private upload = () => {
    if (!this.$scope.picFile) {
      return;
    }

    const imageEl = document.querySelector<HTMLImageElement>(".img-holder img");
    const imageWidth = imageEl.naturalWidth;
    const imageHeight = imageEl.naturalHeight;

    this.$scope.indicators.uploading = true;

    this.fileService.uploadBrandingImage(this.$scope.picFile).then(
      (result) => {
        this.$scope.indicators.uploading = false;

        // get the optimized preset, so we don't serve the super large version
        // imageWidth and imageHeight guarantee that image will not be distorted when received from cloudinary
        // add fake version tag in case domain name of account is of the format: 'v' + numbers => leads to wrong pathname to image
        const url = result.url.replace("upload/", `upload/w_${imageWidth},h_${imageHeight}/q_auto:eco/v100/`).replace("http:", "https:");

        this.accountService.setAccountSetting("branding", url);
        this.$scope.uploadedFileUrl = url;

        const brandingImage: IBrandingImage = { url };
        this.$rootScope.$broadcast("brandingImageChanged", brandingImage);
      },
      (err) => this.uiErrorHandlingService.handleModal(err)
    );
  };

  private delete = () => {
    this.fileService.deleteBrandingImage().then(
      () => {
        this.accountService.setAccountSetting("branding", null);

        this.$scope.picFile = null;
        this.$scope.uploadedFileUrl = null;

        this.$rootScope.$broadcast("brandingImageChanged", null);
      },
      (err) => this.uiErrorHandlingService.handleModal(err)
    );
  };
}
